import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { AuthNavbarComponent } from '@/app/layouts/auth-layout/auth-navbar/auth-navbar';
import { PublicFooterComponent } from '@/app/layouts/public-layout/footer/footer';
import { LanguageFacade } from '@/app/core/language/facades/language.facade';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, AuthNavbarComponent, PublicFooterComponent],
  templateUrl: './auth-layout.html',
  styleUrl: './auth-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayoutComponent {
  private readonly languageFacade = inject(LanguageFacade);
}
